import { __awaiter, __generator } from "tslib";
import { _Web, Web } from "../webs/types.js";
import { spPost } from "../operations.js";
_Web.prototype.hubSiteData = function (forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.clone(Web, "hubSiteData(" + forceRefresh + ")")()];
                case 1:
                    data = _a.sent();
                    if (typeof data === "string") {
                        return [2 /*return*/, JSON.parse(data)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
};
_Web.prototype.syncHubSiteTheme = function () {
    return spPost(this.clone(Web, "syncHubSiteTheme"));
};
//# sourceMappingURL=web.js.map